import * as React from "react";

function SvgEye(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.698 4.852C12.194 3.085 10.297 2 8 2 5.703 2 3.806 3.085 2.302 4.852 1.425 5.884.86 6.911.572 7.628L.422 8l.15.372c.287.717.852 1.744 1.73 2.776C3.803 12.915 5.701 14 8 14c2.298 0 4.196-1.085 5.699-2.852.877-1.032 1.442-2.06 1.73-2.776L15.576 8l-.149-.372c-.287-.717-.853-1.744-1.73-2.776zm-1.524 1.296A9.42 9.42 0 0113.399 8a9.408 9.408 0 01-1.224 1.852C11.02 11.21 9.638 12 8 12s-3.02-.79-4.175-2.148A9.414 9.414 0 012.601 8a9.726 9.726 0 011.225-1.852C4.981 4.79 6.363 4 8 4c1.637 0 3.02.79 4.174 2.148zM8 11a3 3 0 110-6 3 3 0 010 6zm1-3a1 1 0 11-2 0 1 1 0 012 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgEye;
